import service from '@/utils/server';

const modName = '/md/trackShipToFile/';
// 分页查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
// 印章图片上传
export const uploadSealImg = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'uploadSealImg',
    method: 'post',
    data
  });
};
// 附件上传
export const uploadAttach = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'uploadAttach',
    method: 'post',
    data
  });
};
// 附件详情列表
export const attachDetail = data => {
  return service({
    url: modName + 'attachDetail',
    method: 'post',
    params: data
  });
};
// 批量删除
export const deleteBatch = data => {
  return service({
    url: modName + 'deleteBatch',
    method: 'post',
    data
  });
};
// 印章图片批量下载(按DC+年份)
export const batchDownloadSealImg = data => {
  return service({
    url: modName + 'batchDownloadSealImg',
    method: 'post',
    data,
    responseType: 'blob'
  });
};
// 附件批量下载(按DC)
export const batchDownloadAttach = data => {
  return service({
    url: modName + 'batchDownloadAttach',
    method: 'post',
    data,
    responseType: 'blob'
  });
};
// 根据DC查询shipto选项列表
export const shiptoByDc = data => {
  return service({
    url: modName + 'shiptoByDc',
    method: 'post',
    params: data
  });
};
// 查看印章图片(根据DC+shipToNo)
export const viewSealImg = data => {
  return service({
    url: modName + 'viewSealImg',
    method: 'post',
    params: data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/shipToSeal/api/index.js